<template>
  <div class="select-family">
    <h4 class="select-family-header">Use the drilldown to select a family</h4>

    <transition name="fade" mode="out-in">
      <!-- eslint-disable -->
      <div
        v-for="(step, index) in wizardData"
        :key="index"
        v-if="index === currentStepIndex"
      >
        <!-- eslint-enable -->

        <ImageRadioBlocks
          :content="step.data"
          :chosen="step.chosen"
          @change="update(step, ...arguments)"
        ></ImageRadioBlocks>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import { EventBus } from "@/eventbus.js";

//images
import * as modulesIndoorPoint from "@/assets/img/modules-indoor-point.jpg";
import * as modulesIndoorLinear from "@/assets/img/modules-indoor-linear.jpg";
import * as modulesOutdoor from "@/assets/img/modules-outdoor.jpg";
import * as driversIndoorPoint from "@/assets/img/drivers-indoor-point.jpg";
import * as driversIndoorLinear from "@/assets/img/drivers-indoor-linear.jpg";
import * as driversOutdoor from "@/assets/img/drivers-outdoor.jpg";
import * as driversTrustSight from "@/assets/img/drivers-trustsight.jpg";
import * as placeholder from "@/assets/img/140x140_placeholder_2.jpg";

function mapModuleOrDriverToCheckboxItem(item, type) {
  return {
    id: item.id,
    type: type,
    image: (function () {
      if (item.image === null) {
        if (type === "module") {
          switch (item.id) {
            case 1:
              return modulesIndoorPoint;
            case 6:
              return modulesIndoorLinear;
            case 49:
              return modulesOutdoor;
            default:
              return placeholder;
          }
        } else if (type === "driver" || type === "emergency-driver") {
          switch (item.id) {
            case 7:
              return driversIndoorPoint;
            case 1:
              return driversIndoorLinear;
            case 37:
              return driversOutdoor;
            case 325:
              return driversTrustSight;
            default:
              return placeholder;
          }
        }
      } else {
        return `https://www.api.easydesignintool.signify.com/${item.image}`;
      }
    })(),
    title: item.name,
    parentId: item.parentId,
    viewStatus: item.viewStatus,
  };
}

export default {
  name: "SelectFamily",
  props: ["throughAllSteps"],
  data() {
    return {
      loading: false,
      activeStep: null, //becomes obj
      familyGroup: null, //string 'modules' or 'drivers'
      activeFamilyType: null,
      modules: null,
      drivers: null,
      maxWizardDepth: 2,
      wizardData: [],
    };
  },
  created() {
    Promise.all([
      this.$store.dispatch("brain/drivers/getAllDriverFamilies"),
      this.$store.dispatch("brain/modules/getAllModuleFamilies"),
    ]).then(() => {
      this.drivers = this.driverFamilies.map((item) =>
        mapModuleOrDriverToCheckboxItem(item, this.getDriverType(item.id))
      );
      this.modules = this.moduleFamilies.map((item) =>
        mapModuleOrDriverToCheckboxItem(item, "module")
      );

      Vue.set(this.wizardData, 0, {
        chosen: null,
        data: {
          modules: this.modules.filter((item) => item.parentId === null),
          drivers: this.drivers.filter((item) => item.parentId === null),
        },
      });

      this.activeStep = this.wizardData[0];

      this.$emit("changeNextButtonDisabled", this.nextButtonDisabled);
      this.$emit("changeNextButtonVisibility", this.nextButtonVisible);
      this.$emit(
        "changeShowResultsButtonVisibility",
        this.showResultsAvailable
      );
      this.$emit("changeShowResultsButtonDisabled", this.showResultsDisabled);
    });
  },
  computed: {
    ...mapState("brain/modules", ["moduleFamilies"]),
    ...mapState("brain/drivers", ["driverFamilies"]),

    currentStepIndex() {
      return this.wizardData.findIndex(
        (wizardItem) => wizardItem === this.activeStep
      );
    },
    currentStepSelected() {
      if (this.activeStep === null) return false;
      return this.wizardData[this.currentStepIndex].chosen !== null;
    },
    showResultsAvailable() {
      if (this.currentStepIndex === 0 && !this.currentStepSelected)
        return false;

      return this.currentStepSelected || this.currentStepIndex > 0;
    },
    nextStepExists() {
      if (this.currentStepIndex === this.maxWizardDepth) return false;

      return this.currentStepIndex + 1 !== this.wizardData.length;
    },
    nextButtonDisabled() {
      return !this.currentStepSelected || !this.nextStepExists;
    },
    nextButtonVisible() {
      return this.nextStepExists || !this.currentStepSelected || this.loading;
    },
    showResultsDisabled() {
      return !this.currentStepSelected;
    },
  },
  watch: {
    nextButtonDisabled(val) {
      this.$emit("changeNextButtonDisabled", val);
    },
    nextButtonVisible(val) {
      this.$emit("changeNextButtonVisibility", val);
    },
    showResultsAvailable(val) {
      this.$emit("changeShowResultsButtonVisibility", val);
    },
    showResultsDisabled(val) {
      this.$emit("changeShowResultsButtonDisabled", val);
    },
  },
  methods: {
    getDriverType(familyId) {
      const productFamily = this.driverFamilies.find(
        (driverFamily) => driverFamily.id === familyId
      );
      if (productFamily.parentId === null) {
        if (
          productFamily.name === "TrustSight Indoor Emergency" ||
          productFamily.name ===
            "Determine optimum Bodine Emergency Driver here"
        ) {
          return "emergency-driver";
        } else {
          return "driver";
        }
      }
      return this.getDriverType(productFamily.parentId);
    },
    update(step, chosenItem) {
      step.chosen = chosenItem;
      this.familyGroup = chosenItem.type === "module" ? "modules" : "drivers";
      this.activeFamilyType = chosenItem.type;

      const chosenObj = this[this.familyGroup].find(
        (item) => item.id === chosenItem.id
      );
      const children = this[this.familyGroup].filter(
        (item) => item.parentId === chosenObj.id
      );

      if (children.length > 0) {
        Vue.set(this.wizardData, this.currentStepIndex + 1, {
          chosen: null,
          data: children,
        });
      } else {
        //no more children
      }
    },
    nextStep() {
      if (!this.currentStepSelected) return;
      if (this.currentStepIndex + 1 === this.wizardData.length) return; //no more children

      this.activeStep = this.wizardData[this.currentStepIndex + 1];
    },
    prevStep() {
      if (this.currentStepIndex === 0) {
        this.throughAllSteps
          ? this.$emit("prev", "selectFamily")
          : this.$emit("to", "guideMeThrough");
      } else {
        this.activeStep = this.wizardData[this.currentStepIndex - 1];
      }
    },
    showResults() {
      let stepNr =
        this.wizardData[this.currentStepIndex].chosen === null
          ? this.currentStepIndex - 1
          : this.currentStepIndex;

      let stepToCheck = this.wizardData[stepNr];

      const filterName =
        (this.familyGroup === "modules"
          ? "moduleFamilyFilter_"
          : "driverFamilyFilter_") +
        (stepNr + 1);
      const filterDataToSet = {
        name: filterName,
        values: [stepToCheck.chosen.title],
      };

      this.$store.dispatch("brain/global/setClearFilters").then(() => {
        if (this.activeFamilyType === "emergency-driver") {
          if (this.$route.name !== "emergencyDriver") {
            this.$emit("close");
            this.$store.commit("brain/global/setBusy", true);
            this.$store
              .dispatch("brain/emergencyDrivers/getEmergencyDrivers")
              .then(() => {
                if (stepNr === 2) {
                  this.$store.commit(
                    `brain/emergencyDrivers/updateFilter`,
                    filterDataToSet
                  );
                }
                this.$router.push({ name: "emergencyDriver" }, () => {
                  this.$store.commit("brain/global/setBusy", false);
                });
              });
          } else {
            if (stepNr > 2) {
              EventBus.$emit(`brain/emergencyDrivers/handleFilterChange`, {
                addToHistory: true,
                data: filterDataToSet,
              });
            }
            this.$emit("close");
          }
        } else {
          if (this.$route.name !== "advanced") {
            const getModulesOrDrivers =
              this.familyGroup === "modules"
                ? "brain/modules/getModules"
                : "brain/drivers/getDrivers";

            this.$emit("close");
            this.$store.commit("brain/global/setBusy", true);

            this.$store.dispatch(getModulesOrDrivers).then(() => {
              //first do an initial load of all drivers or modules...
              this.$store.commit(
                //then apply a filter
                `brain/${this.familyGroup}/updateFilter`,
                filterDataToSet
              );

              this.$router.push({ name: "advanced" }, () => {
                //this will re-trigger the load of modules and drivers but what can you do.
                this.$store.commit("brain/global/setBusy", false);
              });
            });
          } else {
            EventBus.$emit(`brain/${this.familyGroup}/handleFilterChange`, {
              addToHistory: true,
              data: filterDataToSet,
            });
            this.$emit("close");
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wizard {
  margin-bottom: 50px;
}

.select-family-header {
  color: $blue;
}

.link-btn {
  float: right;
  text-decoration: underline;
}
</style>
